var Listener = /** @class */ (function () {
    function Listener(owner, event, listener, 
    /** @private */ _internal) {
        if (_internal === void 0) { _internal = false; }
        this.owner = owner;
        this.event = event;
        this.listener = listener;
        this._internal = _internal;
    }
    Listener.prototype.unbind = function () {
        this.owner.removeListener(this);
    };
    return Listener;
}());
export { Listener };
